export default function PlugAndPlay(props: any) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none" {...props}>
            <path
                d="M11 11.2569C11 11.115 11.115 11 11.2569 11H32.7431C32.885 11 33 11.115 33 11.2569V22C33 28.0751 28.0751 33 22 33C15.9249 33 11 28.0751 11 22V11.2569Z"
                stroke="black"
                strokeWidth="2"
            />
            <path d="M18.3333 11V3.66663" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M25.6667 11V3.66663" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M20.1667 24.75H23.8334" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M22 33V37.5833C22 39.1022 23.2312 40.3333 24.75 40.3333H34.8333"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
